import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MegaTest.css';

const Loading = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/mega-test/result');
        }, 3000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="loading-container">
            <div className="loader-box">
                <div className="dual-spinner"></div>
                <h2>Analyzing...</h2>
                <p>SEB · 행동 지표 계산 중</p>
                <div className="progress-dots">
                    <span></span><span></span><span></span>
                </div>
            </div>


        </div>
    );
};

export default Loading;
